import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AssessmentService } from 'src/app/core/services/assessment.service';
import { CommonService } from 'src/app/core/services/common.service';
import { LoginService } from 'src/app/core/services/login.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { NotificationComponent } from 'src/app/shared/layouts/notification/notification.component';

@Component({
  selector: 'app-otp-generation',
  templateUrl: './otp-generation.component.html',
  styleUrls: ['./otp-generation.component.css']
})
export class OtpGenerationComponent implements OnInit {
  @Output() verifyOtpEvent: EventEmitter<any> = new EventEmitter<any>();
  @Input() contactguid: any;
  @Input() otpDetailsData: any;
  allowdKeys = [
    'backspace',
    'delete',
    'arrowleft',
    'arrowright',
    'arrowdown',
    'arrowup',
  ];
  otpDetails: any = {};
  otp: any;
  ivValue: any;
  otpGenerated = false;
  otpForm: any;
  isSubmitted = false;
  showOtpNotification = false;
  wrongOtp = false;
  ifSetPswrd: any;
  contactEmailId: any;
  timerOn: any;
  mnt: any;
  sec: any;
  showResendOtp: any;
  ifResend: boolean = false;
  modalRef!: BsModalRef;
  ifReachAttempt: any;
  countAttempt: any = 0;
  countAttemptResend: any = 0;
  remainingTime: any;
  endTimeOtp: any;
  startTimeOtp: any;
  expiredOtp: any;
  isDeactivated = false;
  constructor(private activateRoute: ActivatedRoute, public formBuilder: FormBuilder, private loginService: LoginService,
    private commonService: CommonService, private route: Router, private assessmentService: AssessmentService,
    private modalService: BsModalService) { }

  ngOnInit(): void {
    this.activateRoute.queryParams.subscribe((queryParam: any) => {
      if (queryParam.hasOwnProperty('Contactid') && queryParam.hasOwnProperty('Key')) {
        this.contactguid = queryParam.Contactid;
        this.ivValue = queryParam.Key;
        this.ifSetPswrd = false;
      } else {
        let contactguid = this.loginService.getContactguid();
        if (contactguid) {
          this.contactguid = contactguid;
          this.ifSetPswrd = true;
        }
      }
    });
    this.otpForm = this.formBuilder.group({
      otp: ['', [Validators.required]]
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    //console.log(changes);
    if (changes.hasOwnProperty('otpDetailsData')) {
      this.otpDetails = this.otpDetailsData;
      if (this.otpDetails.isOtpSent) {
        this.otp = this.otpDetails.otpValue;
        this.startTimeOtp = this.otpDetails.otpSentTime;
        if (this.otpDetails.otpSentTime) {
          this.showOtpNotification = true;
          this.otpGenerated = true;

          this.endTimeOtp = this.startTimeOtp + (30 * 60000);
          const d = new Date();
          let currentTime = d.getTime();

          if (this.endTimeOtp > currentTime) {
            this.remainingTime = this.endTimeOtp - currentTime;
            this.timerOn = true;
            this.startTimer(this.remainingTime);
          } else {

            this.expiredOtp = true;
            this.timerOn = false;
            this.showOtpNotification = false;
            this.otpGenerated = false;
          }
        } else {
          this.showOtpNotification = false;
          this.otpGenerated = false;
        }
      }
      else {
        this.showOtpNotification = false;
        this.otpGenerated = false;
      }
    }
  }

  checkNumber(event: any) {
    if (
      !this.allowdKeys.includes(event.key?.toLowerCase()) &&
      isNaN(Number(event.key)) && event.which != 9
    ) {
      event.preventDefault();
      return;
    }
  }

  verifyIfRegistered(action: string) {
    let rqstBody;
    if (this.ifSetPswrd) {
      rqstBody = { contactguid: this.contactguid, ifSetPswrd: true };
    } else {
      rqstBody = { contactguid: this.contactguid, auth: this.ivValue, ifSetPswrd: false };
    }
    this.assessmentService.getNewUserData(rqstBody).subscribe((res) => {
      let decryptedData = this.commonService.decryptUsingAES256(res?.data);
      //console.log('get user data in user profile: ', decryptedData);
      let userDetails = JSON.parse(JSON.stringify(decryptedData));
      //console.log('user details in otp component: ',userDetails);
      let isAlreadyRegistered = userDetails.isAlreadyRegistered;
      if (!userDetails?.isActivate) {
        this.isDeactivated = true;
      }
      this.otpDetails.isOtpSent = userDetails.isOtpSent;
      this.otpDetails.otpValue = userDetails.otpValue;
      this.otpDetails.resendotpcount = userDetails.resendotpcount;
      this.otpDetails.wrongotpcount = userDetails.wrongotpcount;
      this.otpDetails.otpSentTime = userDetails.otpSentTime;
      if (this.isDeactivated) {
        this.showDeactivationPopup();
      } else {
        if (isAlreadyRegistered && !this.ifSetPswrd) {
          this.openAlreadyRegisteredPopup();
        } else {
          this.actionWiseCallOtpFunction(action);
        }
      }
    });
  }

  actionWiseCallOtpFunction(action: string) {
    if (action == 'generateOtp') {
      this.generateOtp();
    } else if (action == 'verifyOtp') {
      this.verifyOtp();
    } else if (action == 'resendOtp') {
      this.resendOtp();
    }
  }

  openAlreadyRegisteredPopup() {
    let message = 'This contact has already completed the registration process.';
    const initialState = {
      message: message,
      redirectTo: 'login',
      cancelButton: false
    };
    this.modalRef = this.modalService.show(NotificationComponent, { ignoreBackdropClick: true, initialState });
  }

  showDeactivationPopup() {
    let pathUrl = 'login';
    let message = 'Contact/Assessment Entity has been deactivated.';
    const initialState = {
      message: message,
      redirectTo: pathUrl,
      cancelButton: false
    };
    this.modalRef = this.modalService.show(NotificationComponent, { ignoreBackdropClick: true, initialState });
  }

  generateOtp() {
    this.otpForm.reset();
    let OTP = '';
    let digits = '1234567890'
    for (let i = 0; i < 6; i++) {
      OTP += digits[Math.floor(Math.random() * 10)];
    }
    this.otp = OTP;
    //console.log(this.otp);
    this.expiredOtp = false;
    const d = new Date();
    this.startTimeOtp = d.getTime();
    this.endTimeOtp = this.startTimeOtp + (30 * 60000);
    this.remainingTime = this.endTimeOtp - this.startTimeOtp;
    this.timerOn = true;
    this.startTimer(this.remainingTime);
    let rqstBody: any;
    rqstBody = {
      contactguid: this.contactguid,
      generatedOtp: this.otp,
      ifSetPswrd: this.ifSetPswrd,
      auth: this.ivValue,
      countAttempt: 0,
      countAttemptResend: 0,
      otpSentTime: this.startTimeOtp
    };
    this.sendEmailWithOtp(rqstBody, false);
  }

  resendOtp() {
    this.otpForm.reset();
    if ((this.otpDetails.resendotpcount + 1) > 3) {
      let rqstBody: any;
      rqstBody = {
        contactguid: this.contactguid,
        ifSetPswrd: this.ifSetPswrd,
        auth: this.ivValue,
        generatedOtp: this.otp,
        countAttempt: this.otpDetails.wrongotpcount,
        countAttemptResend: this.otpDetails.resendotpcount
      };
      this.loginService.updateWrongOtpCount(rqstBody).subscribe((data: any) => {
        //console.log('otp count sent: ',data);
        let decryptedData = this.commonService.decryptUsingAES256(data?.data);
        if (decryptedData?.success == true) {
          this.ifReachAttempt = true;
          this.otpGenerated = false;
          this.timerOn = false;
        }
      });
    } else {
      let rqstBody: any;
      rqstBody = {
        contactguid: this.contactguid,
        generatedOtp: this.otp,
        ifSetPswrd: this.ifSetPswrd,
        auth: this.ivValue,
        countAttempt: this.otpDetails.wrongotpcount,
        countAttemptResend: (this.otpDetails.resendotpcount + 1),
        otpSentTime: this.otpDetails.otpSentTime.toString()
      };
      //console.log('resend rqstbody: ',rqstBody)
      this.sendEmailWithOtp(rqstBody, true);
    }

  }

  sendEmailWithOtp(rqstBody: any, isResend: boolean) {
    this.loginService.sendEmailWithOtp(rqstBody).subscribe((data: any) => {
      //console.log('email sent: ',data);
      let decryptedData = this.commonService.decryptUsingAES256(data?.data);
      if (decryptedData?.isEmailSent == true) {
        this.showOtpNotification = true;
        this.otpGenerated = true;
        if (isResend) {
          this.ifResend = true;
          this.wrongOtp = false;
        } else {
          this.wrongOtp = false;
          this.ifResend = false;
          this.ifReachAttempt = false;
        }
      }
    });

  }

  startTimer(remaining: any) {
    let m: any = Math.floor(remaining / 60000);
    let s: any = ((remaining % 60000) / 1000).toFixed(0);

    this.mnt = m < 10 ? '0' + m : m;
    this.sec = s < 10 ? '0' + s : s;

    remaining -= 1000;

    if (remaining >= 0 && this.timerOn) {
      setTimeout(() => {
        this.startTimer(remaining);
      }, 1000);
      return;
    } else {
      this.timerOn = false;
      if (remaining <= 0) {
        this.expiredOtp = true;
      }
      /* end of time */
    }

    if (!this.timerOn) {
      this.otpGenerated = false;
      if (!this.ifReachAttempt) {
        this.showOtpNotification = false;
      }
      return;
    }
  }

  verifyOtp() {
    this.isSubmitted = true;

    if (this.otpForm.valid) {

      let otpEntered = this.otpForm.value.otp;

      let rqstBody: any;
      rqstBody = {
        contactguid: this.contactguid,
        ifSetPswrd: this.ifSetPswrd,
        auth: this.ivValue,
        generatedOtp: this.otp,
        countAttempt: (this.otpDetails.wrongotpcount + 1),
        countAttemptResend: this.otpDetails.resendotpcount
      };
      if (otpEntered == this.otp) {
        rqstBody['countAttempt'] = 0;
      }
      this.loginService.updateWrongOtpCount(rqstBody).subscribe((data: any) => {
        //console.log('otp count sent: ',data);
        let decryptedData = this.commonService.decryptUsingAES256(data?.data);
        if (decryptedData?.success == true) {
          if (otpEntered == this.otp) {
            if (this.ifSetPswrd) {
              this.loginService.setIfOtpAuthenticated(true);
              this.route.navigate(['forget-password']);
            } else {
              this.verifyOtpEvent.emit(true);
            }
          } else {
            this.wrongOtp = true;
            this.ifResend = false;
            this.otpForm.reset();
            if ((this.otpDetails.wrongotpcount + 1) >= 4) {
              this.ifReachAttempt = true;
              this.otpGenerated = false;
              this.timerOn = false;
            }
            if (this.ifSetPswrd) {

            } else {
              this.verifyOtpEvent.emit(false);
            }
          }
        }

      });
    }

  }

}
